import { useId } from 'react';
import { getFriendlyResultsCount } from './utils/results-helpers';

export default function SearchHeader({ results, orderOptions, orderBy, onSortChange, includeBngProperties, introHeading, introText }) {

    const msg = getFriendlyResultsCount(results, includeBngProperties, 500);

    const sortOptions = orderOptions != null && orderOptions.map(x =>
        <option key={x.Key} value={x.Key}>{x.Value}</option>
    );

    const sortElementId = useId();

    return (
        <div className="grid-container">
        <div className="flex-container align-justify wrap">
            <div className="w-50 w-100-m">
                <h1 className="h5 count-label mb-0" dangerouslySetInnerHTML={({ __html: msg })}></h1>
                {introHeading && 
                    <h2 className="intro-heading">{introHeading}</h2>
                }
                {introText &&
                    <div dangerouslySetInnerHTML={({ __html: introText })}></div>
                }
            </div>
            {results != null && results.TotalResults > 0 && orderOptions != null &&
                <div className="header-sort w-50 w-100-m">
                    <label htmlFor={sortElementId} className="mr-1">Sort by:</label>
                    <div className="select-item" itemID={sortElementId}>
                            <select id={sortElementId} className="mb-0" name="SearchForm.OrderBy" onChange={onSortChange} defaultValue={orderBy}>
                            {sortOptions}
                        </select>
                    </div>
                </div>
            }
            </div>
        </div>
    );
}